import PhotosMultiStructureMenu from './PhotosMultiStructureMenu';

export default PhotosMultiStructureMenu;
